import { Component, OnInit, ViewChild } from '@angular/core';
import{ FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ApiService } from '../../../services/api.service';
import { Location, DatePipe } from '@angular/common';
import * as moment from "moment";
import { DateTimeAdapter } from '@danielmoncada/angular-datetime-picker';


@Component({
  selector: 'app-message',
  templateUrl: './message.page.html',
  styleUrls: ['./message.page.scss'],
})

export class MessagePage implements OnInit {

  messageForm:FormGroup;
  submitted = false;
  messageId: string;
  message: any = {};
  tempMessage: any = {}
  messages: any = {};
  showPage: boolean = false;
  prorityData:any = [];

  locale: any;
  tempLocale: any;

  startDate: any;
  endDate: any;

  breadcrumb: any = {
    MessageSubject: null
  }

  config: any = {
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Roboto', 'sans-serif;', 'Times New Roman', 'Verdana'],
    height: 300,
    toolbar: [
      ['headline', ['style']],
      ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['picture','video', 'link']],
      ['table', ['table']]
    ]
  };


  constructor(private router: Router, private route: ActivatedRoute,
    private dateTimeAdapter: DateTimeAdapter<any>,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private _apiService: ApiService,
    public _commonService: CommonService,
    private location: Location) {
    }
data:any=[];
  ngOnInit() {
    this.messageForm = this.formBuilder.group({
      Subject: ['', Validators.required],
      Body: ['', Validators.required],
      Priority: ['', Validators.required],
      StartDate: ['', Validators.required],
      EndDate: ['', Validators.required]
    });

    this.data = [
      {
        id: '',
        text: ''
      },
      {
        id: 'high',
        text: this._commonService.getLocalTranslation('label-high')
      },
      {
        id: 'low',
        text: this._commonService.getLocalTranslation('label-low')
      },
      {
        id: 'medium',
        text: this._commonService.getLocalTranslation('label-medium')
      }
    ];

  }

  ionViewWillEnter(){
    this.messageForm.controls['StartDate'].setErrors(null);
    this.messageForm.controls['EndDate'].setErrors(null);
  }

  ionViewDidEnter() {
    this.messageId= this.route.snapshot.paramMap.get('id');
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    if(this.locale == '1043'){
      this.dateTimeAdapter.setLocale('nl');
      this.config.lang = 'nl-NL';
    }else {
      this.dateTimeAdapter.setLocale('en');
    }
    if (this.messageId == '0') {
      this.messageId = null;
    }
    if (this.messageId) {
      this.getMessageDetails();
    } else {
      this.startDate = new Date(moment().format());
      this.endDate = new Date(moment().add(1, 'year').format());
     this.getLocales();
      this.messageForm.patchValue({
        StartDate: this.datePipe.transform(new Date(this.startDate), "dd-MM-yyyy HH:mm"),
        EndDate: this.datePipe.transform(new Date(this.endDate), "dd-MM-yyyy HH:mm"),
      })

      this.showPage = true;

      this.messages =
        {
          MessageId: this.messageId,
          Priority: "",
          StartDate: "",
          EndDate: "",
          Translations: [
            {
              Subject: "",
              Body: "",
              LocaleId: this.locale,
            }
          ]
        }
    }
    }
    ionViewDidLeave(){
      this.showPage=false;
    }


  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        let icon;
        this.message.AllLocales = JSON.parse(localStorage.domainLocales);

      } else {
        let icon;
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.message.AllLocales = localeData.body;
        localStorage.domainLocales = JSON.stringify(localeData.body);
        // for(let i=0;i<this.message.AllLocales.length;i++){
        //   if(this.message.AllLocales[i].LocaleIconUrl=='flag-icon-nl'){
        //     icon='nl.svg'
        //   }
        //   if(this.message.AllLocales[i].LocaleIconUrl=='flag-icon-gb'){
        //     icon='gb.svg'
        //   }
        //   let value={
        //   id:this.message.AllLocales[i].LocaleId,
        //   text:this.message.AllLocales[i].Locale,
        //   additional: {
        //     image: icon,
        //     winner: i+1
        //   }
        //   }
        //   this.AllLocales.push(value);
        //   icon='';
        // }
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

    async getMessageDetails() {
      try {
        this._commonService.presentLoading();
        let res = await this._apiService.getMessage(this.messageId);
        this.messages = res.body;
        await this.getLocales();
        this._commonService.log(this.messages, this._commonService.LOG);
        this.startDate = this.messages.StartDate;
        this.endDate = this.messages.EndDate;
        this.tempMessage =  this.message

        let message = this.messages.Translations.find(x => x.LocaleId == this.locale);

        this.breadcrumb.MessageSubject = message.Subject

        this.messageForm.patchValue({
          Subject: message.Subject,
          Body: message.Body,
          Priority: this.messages.Priority ,
          StartDate: this.datePipe.transform(new Date(this.messages.StartDate), "dd-MM-yyyy HH:mm"),
          EndDate: this.datePipe.transform(new Date(this.messages.EndDate), "dd-MM-yyyy HH:mm"),
          })
        this._commonService.dismiss();
        this. messageForm.updateValueAndValidity();
        this.showPage = true;
        } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
        }
       }

     get f() { return this.messageForm.controls; }

    async  onSubmit() {
      this.submitted = true;
      if(this.messageForm.value.StartDate == ''){
        this.messageForm.controls['StartDate'].setErrors({'incorrect': true});
       }
       else{
        this.messageForm.controls['StartDate'].setErrors(null);
       }
       if(this.messageForm.value.EndDate == ''){
        this.messageForm.controls['EndDate'].setErrors({'incorrect': true});
       }
       else{
        this.messageForm.controls['EndDate'].setErrors(null);
       }
      if (this.messageForm.invalid) {
        this._commonService.scrollToError();
        return;
      }
      this._commonService.presentLoading();
        try {
          let message = this.messages.Translations.find(x => x.LocaleId == this.locale);
          message.Body = this.messageForm.value.Body;
          message.Subject = this.messageForm.value.Subject;
          this.messages.Priority = this.messageForm.value.Priority;
          this.messages.StartDate = this._commonService.getTimeZone(this.startDate);
          this.messages.EndDate = this._commonService.getTimeZone(this.endDate);
          this.messages.MessageId = this.messageId;
          let res = await this._apiService.postMessage(this.messages);
          if(res.id){
            this.messageId = res.id;
            this.location.replaceState('maintenance/messages/' + this.messageId);
          }
          this._commonService.log(this.messages, this._commonService.LOG);
          this._commonService.dismiss();
          this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
           this.submitted = false;
       }
       catch (error) {
        if(error.status >= 500 && error.status < 600){
          let message = this.tempMessage.Translations.find(x => x.LocaleId == this.locale);
          this.breadcrumb.MessageSubject = message.Subject
          this.messageForm.patchValue({
            Subject: message.Subject,
            Body: message.Body,
            Priority: this.messages.Priority ,
            StartDate: this.datePipe.transform(new Date(this.messages.StartDate), "dd-MM-yyyy HH:mm"),
            EndDate: this.datePipe.transform(new Date(this.messages.EndDate), "dd-MM-yyyy HH:mm"),
            })

        }
       this._commonService.dismiss();

       this._commonService.log(error, this._commonService.ERROR);
       }
     }

     delete() {
      this._commonService.presentAlertConfirm()
        .then(async (res) => {
          try {
            this._commonService.presentLoading();
            await this._apiService.deleteMessages(this.messageId);
            this._commonService.dismiss();
            this._commonService.log(res, this._commonService.LOG);
            this.goBack();
           }  catch (error) {
            this._commonService.dismiss();
            this._commonService.log(error, this._commonService.ERROR);
            }
        })
        .catch((err) => {
          this._commonService.log(err, this._commonService.LOG);
         })
      }


     goBack() {
      this.location.back();
    }

    dateTimeChange(event){
      this.startDate = event.value;
      this.messageForm.patchValue({
        StartDate: this.datePipe.transform(new Date(event.value), "dd-MM-yyyy HH:mm"),
      });

    }

    enddateTimeChange(event){
      this.endDate = event.value;
      this.messageForm.patchValue({
        EndDate: this.datePipe.transform(new Date(event.value), "dd-MM-yyyy HH:mm"),
      })
    }

    minDate(startDate){
      return new Date(new Date(startDate).setMinutes(new Date(startDate).getMinutes() + 1));
    }

    afterStartPickerClosed(event){
      this.startDate = event;
      if(this.startDate){
        this.messageForm.patchValue({
          StartDate: this.datePipe.transform(new Date(event), "dd-MM-yyyy HH:mm"),
        })
      }
      if (this.messageForm.value.StartDate == '' || !this.startDate){
      this.messageForm.controls['StartDate'].setErrors({'incorrect': true});
      }
      else{
      this.messageForm.controls['StartDate'].setErrors(null);
      }
    }

    afterEndPickerClosed(event){
      this.endDate = event;
      if(this.endDate){
        this.messageForm.patchValue({
          EndDate: this.datePipe.transform(new Date(event), "dd-MM-yyyy HH:mm"),
        })
      }
      if (this.messageForm.value.EndDate == '' || !this.endDate){
       this.messageForm.controls['EndDate'].setErrors({'incorrect': true});
      }
      else{
       this.messageForm.controls['EndDate'].setErrors(null);
      }
  }

  chosenEndMonthHandler(event){
    if (event > this.startDate) {
      if(this.endDate){
        this.endDate.setMonth(event.getMonth());
        this.messageForm.patchValue({
          EndDate: this.datePipe.transform(new Date(this.endDate), "dd-MM-yyyy HH:mm"),
        });
      }
    }
  }

  chosenEndYearHandler(event){
    if (event > this.startDate) {
      if(this.endDate){
        this.endDate.setFullYear(event.getFullYear());
        this.messageForm.patchValue({
          EndDate: this.datePipe.transform(new Date(this.endDate), "dd-MM-yyyy HH:mm"),
        });
      }else{
        event.setTime(new Date().getTime())
        this.endDate = event;
        this.messageForm.patchValue({
          EndDate: this.datePipe.transform(new Date(event), "dd-MM-yyyy HH:mm"),
        })
      }
    }
  }

  chosenStartMonthHandler(event) {
    if (this.startDate) {
      this.startDate.setMonth(event.getMonth());
      this.messageForm.patchValue({
        StartDate: this.datePipe.transform(new Date(this.startDate), "dd-MM-yyyy HH:mm"),
      });
    }
  }

  chosenStartYearHandler(event) {
    if (this.startDate) {
      this.startDate.setFullYear(event.getFullYear());
      this.messageForm.patchValue({
        StartDate: this.datePipe.transform(new Date(this.startDate), "dd-MM-yyyy HH:mm"),
      });
    } else {
      event.setTime(new Date().getTime())
      this.startDate = event;
      this.messageForm.patchValue({
        StartDate: this.datePipe.transform(new Date(event), "dd-MM-yyyy HH:mm"),
      })
    }
  }

  changeLocale() {
    if (this.showPage) {
      if (this.messageId && this.messages.Translations) {
        let tempMessage = this.messages.Translations.find(x => x.LocaleId == this.tempLocale);
        tempMessage.Subject = this.messageForm.value.Subject;
        tempMessage.Body = this.messageForm.value.Body;
        this.tempLocale = this.locale;
        let message = this.messages.Translations.find(x => x.LocaleId == this.locale);
        if(message){
          this.messageForm.patchValue({
            Subject: message.Subject,
            Body: message.Body,
          });
        }else{
          this.messages.Translations.push({
            Subject: "",
            Body: "",
            LocaleId: this.locale,
          });
          this.messageForm.controls['Body'].reset();
          this.messageForm.controls['Subject'].reset();
        }
      } else {
        let tempMessage = this.messages.Translations.find(x => x.LocaleId == this.tempLocale);
        if (tempMessage) {
          tempMessage.Subject = this.messageForm.value.Subject;
          tempMessage.Body = this.messageForm.value.Body;
          this.tempLocale = this.locale;
          let message = this.messages.Translations.find(x => x.LocaleId == this.locale);
          if (message) {
            this.messageForm.patchValue({
              Subject: message.Subject,
              Body: message.Body,
            });
          }
          else {
            this.messages.Translations.push({
              Subject: "",
              Body: "",
              LocaleId: this.locale,
            });
            this.messageForm.controls['Body'].reset();
            this.messageForm.controls['Subject'].reset();
            this.tempLocale = this.locale;
          }
        }
      }
    }
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
          this.onSubmit();
          break;
      case "delete":
          this.delete();
          break;
      case "backToList":
          this.goBack();
          break;
      case "backToMain":
          this.router.navigate(['maintenance'], { replaceUrl: true })
          break;
      case "back":
          this.goBack();
          break;
      }

  }

}
